module.exports = __webpack_public_path__ + "static/media/2c.cd80aede.jpg";